module.exports = __webpack_public_path__ + "static/media/specific-risk-red.a5ddcdd8.svg";